























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Project } from '@/types'

@Component
export default class Works extends Vue {
  @Prop() projects!: Array<Project>;

}
